<template>
	<div class="text-white small text-center robotofonts w-100 container-fluid p-0 py-4">
		<div class="py-2 d-flex justify-content-center cprtext">Featured On</div>
		<div class="marquee-container">
			<div class="marquee-track" ref="track">
				<div class="badge"><a href="https://twelve.tools" target="_blank"><img src="https://twelve.tools/badge3-dark.svg" alt="Featured on Twelve Tools"></a></div>
				<div class="badge"><a href="https://wired.business" target="_blank"><img src="https://wired.business/badge2-dark.svg" alt="Featured on Wired Business"></a></div>
				<div class="badge"><a href="https://askaiforit.com/" target="_blank"><img src="https://askaiforit.com/badges/badge-3.svg" alt="Listed on Ask AI For IT"></a></div>
				<div class="badge"><a href="https://startupfa.me/s/techtitans?utm_source=techtitans.cloud" target="_blank"><img src="https://startupfa.me/badges/featured/dark.webp" alt="Techtitans Hub - Featured on Startup Fame" /></a></div>
				<div class="badge">
					<a href="https://projecthunt.me" target="_blank">
						<svg xmlns="http://www.w3.org/2000/svg" class="ph-badge" viewBox="0 0 180 48" role="img" aria-label="Featured on: projecthunt.me">
							<title>Featured on projecthunt.me</title>
							<rect x="0" y="0" width="100%" height="100%" rx="4" fill="#000" stroke="#E85C0D" stroke-width="1.5" />
							<g transform="translate(10, 8)">
								<image href="https://projecthunt.me/favicon.ico" width="32" height="32" />
							</g>
							<g fill="#666666" text-anchor="start" font-family="Verdana, Geneva, DejaVu Sans, sans-serif">
								<text x="50" y="20" font-size="13" font-weight="500">Featured on</text>
								<text x="50" y="36" font-size="14" font-weight="600" fill="#E85C0D">projecthunt.me</text>
							</g>
						</svg>
					</a>
				</div>
				<div class="badge"><a href="https://startuptrusted.com?ref=techtitans.cloud" target="_blank" rel="noopener"><img src="https://startuptrusted.com/api/badge?type=featured&style=dark" alt="TechTitans on StartupTrusted" /></a></div>
				<div class="badge"><a href="https://fazier.com" target="_blank"><img src="https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=featured&theme=dark" alt="Fazier badge" /></a></div>
			</div>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue';

const track = ref < HTMLElement | null > (null);

onMounted(() => {
	const el = track.value;
	if (!el) return;

	// κλωνοποιεί το περιεχόμενο για seamless loop
	el.innerHTML += el.innerHTML;
});
</script>
<style scoped lang="scss">
.cprtext {
	font-size: 14px;
	font-weight: 400;
	line-height: 14.06px;
}

.marquee-container {
	width: 100%;
	overflow: hidden;
	position: relative;
}

.marquee-track {
	display: flex;
	width: max-content;
	animation: scroll 60s linear infinite;
}

.badge {
	flex: 0 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1px 60px;

	@media (max-width: 1500px) {
		padding: 1px 30px;
	}

	@media (max-width: 768px) {
		padding: 1px 20px;
	}
}

.badge a,
.badge img,
.badge svg {
	height: 36px;
	display: block;
}

@keyframes scroll {
	0% {
		transform: translateX(0);
	}

	100% {
		transform: translateX(-50%);
	}
}
</style>